import React, { useEffect, useState } from "react";
import { Button, Col, Form, Image, Row } from "react-bootstrap";
import { useAppContext } from "contexts/AppContext";
import useAuth from "hooks/useAuth";
import { useNavigate, useSearchParams } from "react-router-dom";
import Logo from "assets/white-logo.png";

const Login = () => {
  // contexts
  const { appState } = useAppContext();

  // states
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  // hooks
  const { loading, login, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // functions
  const doLogin = (e) => {
    e.preventDefault();
    login(email.toLowerCase(), password);
  };

  // effects
  useEffect(() => {
    isAuthenticated();
  }, []);

  useEffect(() => {
    if (!loading && appState.auth?.isAuthenticated) {
      if (searchParams.get("redirect")) {
        navigate(searchParams.get("redirect"));
      } else {
        navigate("/dashboard");
      }
    }
  }, [loading, appState]);

  return (
    <React.Fragment>
      <Row className="w-100 justify-content-center text-center">
        <Col sm={12} className="mb-5">
          <Image src={Logo} width="300em" />
          <h1 className="text-white">MGH ERP Sales App</h1>
        </Col>
        <Col sm={12} md={7} lg={5}>
          <Form onSubmit={doLogin}>
            <Form.Group>
              <Form.Control
                type="email"
                className="rounded-pill h-100 my-2"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <Form.Control
                type="password"
                className="rounded-pill h-100 my-2"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              ></Form.Control>
            </Form.Group>
            <Button type="submit" className="my-5" disabled={loading}>
              Login
            </Button>
          </Form>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Login;
